import React from "react";
import PropTypes from "prop-types";
import { APP_ROUTES } from './approutes';
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import HomePage from "../components/dashboard/index";
import { checkIsLoggedIn } from "../services/actions";
import Login from "../components/login/index";
import Dashboard from "../components/dashboard/dashboard";
import CompletedOrders from "../components/dashboard/completedorders";
import MappingList from "../components/dashboard/mappingList";
import MobiLabusers from "../components/dashboard/mobilabUserList";
import CCBulkUpload from "../components/dashboard/ccBulkUpload";
import ForgetPassword from "../components/login/forgetPasword";
import MobilabClinicList from "../components/dashboard/mobilabecliniclist";
import MobilabUserListNew from "../components/dashboard/mobilabUserListNew";
import OrderTracking from "../components/dashboard/patientOrderTracking";
import LabPartnerErrorLogList from "../components/dashboard/errorLogList";
import ReportFailureList from "../components/dashboard/reportFailure";
import CCOnboarding from "../components/dashboard/ccOnboarding";
import CCOnboardingWorkflow from "../components/dashboard/ccOnboardingWorkflow";
import Configuration from "../components/dashboard/Configuration";
import CorporateList from "../components/dashboard/CorporateList";
import CorporateApproval from "../components/dashboard/CorporateApproval";

const PrivateRoute = ({ children }) => {
    const auth = checkIsLoggedIn();
    return auth ? children : <Navigate to={APP_ROUTES.LOGIN} />;
};

PrivateRoute.propTypes = {
    children: PropTypes.node.isRequired
};

const OurRoutes = () => {
    const location = useLocation();

    return (
        <Routes>
            <Route exact path={APP_ROUTES.LOGIN} element={<Login />} />
            <Route exact path={APP_ROUTES.FORGET} element={<ForgetPassword />} />
            <Route exact path={APP_ROUTES.TRACKING} element={<OrderTracking />} />

            <Route
                path={APP_ROUTES.DASHBOARD}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <Dashboard />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.MAPLIST}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <MappingList key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.MOBILABECLIST}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <MobilabClinicList key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.ONBARDING}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <CCOnboardingWorkflow mode="creator" defaultOnboardingType="CC" key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />

            <Route
                path={APP_ROUTES.BUSINESSAPPROVAL}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <CCOnboardingWorkflow mode="businessApproval" key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />

            <Route
                path={APP_ROUTES.FINANCEAPPROVAL}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <CCOnboardingWorkflow mode="financeApproval" key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />

            <Route
                path={APP_ROUTES.CCONBOARDLIST}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <CCOnboardingWorkflow key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />

            <Route
                path={APP_ROUTES.LABONBOARD}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <CCOnboardingWorkflow mode="creator" defaultOnboardingType="LAB" key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.LOG}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <LabPartnerErrorLogList key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.REPORTFAIL}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <ReportFailureList key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.MOBIUSERLIST}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <MobilabUserListNew />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.MOBIUSERNEW}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <MobilabUserListNew />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.COMPLETEDORDERS}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <CompletedOrders />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.CCBULK}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <CCBulkUpload />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.CONFIGURATION}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <Configuration key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route
                path={APP_ROUTES.CORPORATELIST}
                element={
                    <PrivateRoute>
                        <HomePage>
                            <CorporateList key={location.state?.toValue} />
                        </HomePage>
                    </PrivateRoute>
                }
            />
            <Route exact path={APP_ROUTES.CORPORATEAPPROVAL} element={<CorporateApproval />} />
        </Routes>
    );
};

export { OurRoutes };

